import ViewReport from "./component";
import ViewReportContainer from "./container";
export { ViewReport, ViewReportContainer };
export default ViewReportContainer;



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReport/index.ts